import React from "react";

const ApplicationContext = React.createContext({
  cards: [],
  claimsList: [],
  claimsCount: 0,
  orderDetails: null,
  pageSize: 10,
  searchtext: "",
  vehicleDetails: null,
  status: "",
});

export default ApplicationContext;
